// src/data/creditNoteData.js
import axios from "axios";

const API_BASE = "http://192.168.1.248:3103";

const creditNoteData = async (creditNoteId) => {
    try {
        const url = `${API_BASE}/api/get-credit-note-data/${creditNoteId}`;
        const res = await axios.get(url);
        const { master, details } = res.data;

        // Map each detail‐row into the shape your front‐end expects
        const items = (details || []).map((d) => {
            // calculate percentages only if Rate is nonzero:
            const cgstPct = d.Rate ? (d.CGSTAmt / d.Rate) * 100 : 0;
            const sgstPct = d.Rate ? (d.SGSTAmt / d.Rate) * 100 : 0;
            const igstPct = d.Rate ? (d.IGSTAmt / d.Rate) * 100 : 0;

            return {
                hsnCode: d.productCode,
                description: d.description,
                qty: d.Qty,
                rate: d.Rate,
                discount: d.Disc,
                cgst: cgstPct,
                sgst: sgstPct,
                igst: igstPct,
                amount: d.Amount,
            };
        });

        return {
            companyName: master.companyName,
            // We don’t have a single "address" column; instead, combine shipToName + shipToCity + shipToState:
            address: master.shipToName && master.shipToCity && master.shipToState ? `${master.shipToName}, ${master.shipToCity}, ${master.shipToState}` : "",
            phone: master.shipToMobileNo || master.mobileNo || "",
            gstNo: master.gstNumber || "",
            // The front‐end used "invoiceNo" for sale invoices; here we show the CREDIT→REFERENCE:
            invoiceNo: master.creditNoteNumber,
            date: master.creditNoteDate ? new Date(master.creditNoteDate).toLocaleDateString("en-GB") : "",
            transport: master.transporterName || "SELF",
            challanNo: master.lrNumber || "",
            poNo: master.project || "",
            state: master.shipToState || master.state || "",
            // if shipToState is “Gujarat” → “GUJ” etc. You can adjust as needed:
            stateCode: master.shipToState ? master.shipToState.slice(0, 2).toUpperCase() : "",
            LrNo: master.lrNumber || "",
            vehNo: master.vehicleNumber || "",
            LrDate: master.lrDate ? new Date(master.lrDate).toLocaleDateString("en-GB") : "",
            shipToGstNumber: master.shipToGstNumber || "",
            shipToState: master.shipToState || "",
            items,
            toEmail: master.shipToEmailId || master.emailId || "",
            totalAmount: master.grandTotal || 0,
            mobileNo: master.mobileNo || "",
        };
    } catch (err) {
        console.error(`Error loading creditNoteData for id=${creditNoteId}`, err);
        throw err;
    }
};

export default creditNoteData;